import { QrCodeScanner } from '@mui/icons-material';
import Grid from '@mui/material/Grid2';
import { makeStyles } from '@mui/styles';
import React, { useRef, useState } from 'react';
import useSound from 'use-sound';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import ButtonComponent from '#app/Component/ButtonComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';

type Props = {
  onUpdate: (ean: string) => Promise<boolean>;
};

const Scan: React.FC<Props> = ({ onUpdate }) => {
  const classes = useStyles();
  const [beep] = useSound('/mp3/beep.mp3');
  const [boop] = useSound('/mp3/boop.mp3');
  const [isFocus, setFocus] = useState(false);

  const ref = useRef<HTMLInputElement>(null);
  const [formRef, setFormRef] = useState<Form>({
    picking: {
      name: 'picking',
      label: 'picking',
      type: 'text',
    },
  });
  const handlerFormRef = initFormHandler(formRef, setFormRef);

  const onChange = async (value: string) => {
    try {
      const success = await onUpdate(value);

      if (success) {
        beep();
        dispatch(
          SnackbarOpen({
            text: 'Article enregistré.',
            variant: 'success',
          }),
        );
      } else {
        boop();
        dispatch(
          SnackbarOpen({
            text: 'Article introuvable !',
            variant: 'error',
          }),
        );
      }
    } catch {
      boop();
      dispatch(
        SnackbarOpen({
          text: 'Erreur lors de la mise à jour.',
          variant: 'error',
        }),
      );
    }
  };

  return (
    <>
      {isFocus && <QrCodeScanner className={classes.qrCode} />}
      <TextFieldComponent
        style={{ position: 'absolute', right: 0, top: 0, height: 0, width: 50, opacity: 0, zIndex: 1000 }}
        id="picking"
        handler={handlerFormRef}
        onBlur={() => setFocus(false)}
        onFocus={() => setFocus(true)}
        inputRef={ref}
        onScan={onChange}
        autoComplete={false}
      />

      <Grid container justifyContent="flex-end" className={classes.button}>
        {isFocus ? (
          <ButtonComponent
            color={'#a47b00'}
            onClick={() => {
              ref.current?.blur();
            }}
            label="Désactiver le lecteur code barre"
          />
        ) : (
          <ButtonComponent
            onClick={() => {
              ref.current?.focus();
            }}
            label="Activer le lecteur code barre"
          />
        )}
      </Grid>
    </>
  );
};

const useStyles = makeStyles({
  qrCode: {
    color: '#28a745',
    position: 'absolute',
    top: 25,
    right: 50,
    fontSize: 35,
  },
  button: {
    margin: '15px 0',
  },
});

export default Scan;
